<div id="delete-service-dialog-confirmpopup" class="confirmpopup">
    <div id="-delete-service-dialog-dialog-title" mat-dialog-title>
      <label id="delete-service-dialog-title-label" class="title">Delete Booking</label>
    </div>
    <hr id="delete-service-dialog-first-hr">
    <div id="delete-service-dialog-dialog-content" mat-dialog-content>
      <p id="delete-service-dialog-content-p">Are you sure you want to delete this booking?</p>
      <p id="delete-service-dialog-content-p2"><b>"{{serviceData.adxBookingId}}"</b></p>
    </div>
    <hr id="delete-service-dialog-second-hr">
    <div id="delete-service-dialog-dialog-actions" mat-dialog-actions style="float: right;">
      <button
        id="delete-service-dialog-ok-button"
        type="submit" mat-raised-button
        (click)="okClick()"
        color="primary"
        cdkFocusInitial matTooltip="Delete booking"
        aria-label="Delete service">
        <mat-spinner
        id="delete-vcc-dialog-spinner"
        color="accent"
        *ngIf="isLoadingSpinner"
        diameter="30">
      </mat-spinner>
        <span id="delete-service-dialog-ok-span" *ngIf="!isLoadingSpinner">Ok</span>
      </button>
      <button
        id="delete-service-dialog-no-button"
        mat-raised-button
        (click)="onNoClick()"
        color="warn">
        No
      </button>
    </div>
  </div>
